import { createReducer, on } from '@ngrx/store';
import { AppleDeviceApiActions } from './apple-device.actions';
import { AppleDevice } from '@era/locations-sdk';
import { adapter, initialState } from './apple-device.state';

export const appleDeviceReducer = createReducer(
  initialState,
  on(AppleDeviceApiActions.devicePutInLostMode, (state, { udid }) => {
    const appleDeviceLostModeEnabled: AppleDevice = state.entities[udid];
    appleDeviceLostModeEnabled.isMdmLostModeEnabled = true;
    return adapter.upsertOne(appleDeviceLostModeEnabled, state);
  }),
  on(AppleDeviceApiActions.deviceTakenOutOfLostMode, (state, { udid }) => {
    const appleDeviceLostModeDisabled: AppleDevice = state.entities[udid];
    appleDeviceLostModeDisabled.isMdmLostModeEnabled = false;
    return adapter.upsertOne(appleDeviceLostModeDisabled, state);
  }),
  on(AppleDeviceApiActions.appleDeviceLoaded, (state, { appleDevice }) => adapter.upsertOne(appleDevice, state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectDeviceIds = selectIds;

export const selectAppleDeviceEntities = selectEntities;

export const selectAllDevices = selectAll;
